









































helpers = require('../../helpers.coffee')
api = require '../../api.coffee'

view_model = {
  data: () ->
    credentials:
      current_password: ''
      password: ''
      password_confirmation: ''

    apiErrorMessages: []

  methods:
    submit: ->
      @$validator.validateAll(@credentials).then (success) =>
        @changePassword() if success

    changePassword: ->
      Loader.on()
      new UsersResource().changePassword(@changePasswordSuccess, @handleApiErrors, @credentials)

    changePasswordSuccess: ->
      Loader.off()
      IntercomCtrl.trackEvent('Alterou a senha')
      @$router.push { path: '/configuracoes/perfil' }
      alertify.success 'Senha alterada com sucesso'

  mounted: ->
    @errors.clear()
}

exports.default = helpers.vue_include(view_model, helpers.form)



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/configuration/change_password.vue